import { isEmpty } from 'lodash';
export function isEmptyPageGroupFov(target) {
    var _a;
    if (!target || !target.children) {
        return true;
    }
    const fovFilters = (_a = target.children[0]) === null || _a === void 0 ? void 0 : _a.children;
    if (!fovFilters || fovFilters.length < 1 || (fovFilters.length === 1 && isEmpty(fovFilters[0]))) {
        return true;
    }
    return false;
}
//# sourceMappingURL=page-target-utils.js.map